import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TokenApiService } from 'src/app/core/services/token-api.service';
import { TenantLogEntry } from 'src/app/core/domain/developer-token.model';
import { IonicModule } from '@ionic/angular';
import { NgClass, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-logs',
    templateUrl: './logs.page.html',
    styleUrls: ['./logs.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        IonicModule,
        NgClass,
        RouterLink,
        DatePipe,
        TranslatePipe,
    ],
})
export class LogsPage implements OnInit {
  entries: TenantLogEntry[] = [];
  isLoading = true;
  loadError = false;

  constructor(private api: TokenApiService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.isLoading = true;
    this.loadError = false;

    this.api.logs().subscribe({
      next: res => {
        this.entries = res.items;
        this.isLoading = false;
        this.cdr.markForCheck();
      },
      error: () => {
        this.isLoading = false;
        this.loadError = true;
        this.cdr.markForCheck();
      },
    });
  }

  statusColor(statusCode: number): string {
    if (statusCode >= 500) return 'danger';
    if (statusCode >= 400) return 'warning';
    if (statusCode >= 200) return 'success';
    return 'medium';
  }

  methodBadgeClass(method: string): string {
    switch (method.toUpperCase()) {
      case 'GET': return 'method-badge--get';
      case 'POST': return 'method-badge--post';
      case 'PATCH':
      case 'PUT': return 'method-badge--patch';
      case 'DELETE': return 'method-badge--delete';
      default: return 'method-badge--get';
    }
  }
}
